<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../utils.scss";
    $base-color:#79BD50;
  .address {
    height: px2rem(72px);
    display: flex;
    align-items: center;
    padding: 0 px2rem(20px);
    background: white;
    i {
      display: inline-block;
    }
    .address-info {
      flex:1;
      margin-left: px2rem(10px);
      .user {
        color: #333;
        @include font-dpr(16px);
        font-weight: bold;
        line-height: px2rem(20px);
      }
      .street {
        @include font-dpr(14px);
        color: #999;
        line-height: px2rem(20px);
      }
    }
    .pos-icon {
       height: px2rem(24px);
      width: px2rem(18px);
      background: url("../assets/icon_ads@2x.png") no-repeat;
      background-size: contain;
    }

    .more-icon {
      height: px2rem(15px);
      width: px2rem(15px);
      background: url("../assets/icon_arrow@2x.png") no-repeat;
      background-size: contain;
      float: right;
    }

  }

  .bar {
    background: url("../assets/icon_bar@2x.png");
    height: px2rem(3px);
  }

  .checkout {
    max-height: calc(100% - 1.28rem);
    max-height: calc(100vh - 1.28rem);
    overflow: scroll;
    -webkit-overflow-scrolling:touch;
  }

  .goods-list {
      margin-top: px2rem(10px);
      padding-left: px2rem(20px);
      background: white;
      .name {
        border-bottom: 1px solid #e5e5e5;
        @include font-dpr(16px);
        color: #333;
        height: px2rem(44px);
        line-height: px2rem(44px);
      }

      ul {
        padding-bottom:1px;
        border-bottom: 1px solid #e5e5e5;
      }
  }

  .cart-item {
        @include font-dpr(14px);
        color: #666;
        margin-top: px2rem(16px);
        padding: 0 px2rem(20px) 0  0 ;
        &:last-child {
            margin-bottom: px2rem(16px);
         }


         .quantity {
            float: right;
         }

         .price {
            float: right;
            width: px2rem(50px);
           text-align: right;
         }
    }

  .delivery-fee, .total-fee {
      display: flex;
      justify-content: space-between;
      height: px2rem(44px);
      border-bottom: 1px solid #e5e5e5;
    .value {
      @include font-dpr(14px);
      color: #666;
      line-height: px2rem(44px);
      margin-right: px2rem(20px);
    }
  }
  .total-fee .value {
    @include font-dpr(20px);
    color: $base-color;
  }

  .order-info {
    margin-top: px2rem(10px);
    padding-left: px2rem(20px);
    background: white;
    .delivery-time, .order-notes {
      @include font-dpr(14px);
      color: #666;
      display: flex;
      align-items: center;
      height: px2rem(44px);
      border-bottom: 1px solid #e5e5e5;
      line-height: px2rem(44px);

    }
    .delivery-time {
      .name {
        flex: 1;
      }
    }

    .order-notes {
      .name {
        align-self: flex-start;
      }
      height: auto !important;
      textarea {
        resize:none;
        flex: 1;
        margin-left: px2rem(16px);
        margin-top:px2rem(11px);
        border: 0px;
        &::-webkit-input-placeholder {
          color:#ccc;
         }

      }
    }
    .more-select {
        display: inline-block;
      height: px2rem(18px);
      width: px2rem(18px);
      background: url("../assets/icon_arrow@2x.png") no-repeat;
      background-size: contain;
    }
  }

  .first-order {
     margin-top: px2rem(10px);
      padding-left: px2rem(20px);
      background: white;
    @include font-dpr(14px);
    color: #333;
    height: px2rem(44px);
      line-height: px2rem(44px);
      .back {
        float: right;
        background: #c0c0c0;
        border-radius: px2rem(24px);
        height:px2rem(24px);
        width: px2rem(50px);
        margin-right: px2rem(20px);
        margin-top: px2rem(10px);
        border:1px solid #c0c0c0;
      }
      .ball {
        display: inline-block;
        background: white;
        height: px2rem(24px);
        width: px2rem(24px);
        border-radius: px2rem(24px);
        vertical-align: top;

      }
      .ball-check {
        background: $base-color;
        border:1px solid $base-color;
        .ball {
          float: right;
        }
      }

  }
   .bottom-options{
    position: fixed;
    bottom:0;
    z-index: 99;
    height: px2rem(48px);
    width: 100%;
    background: white;
    @include font-dpr(18px);
    box-shadow: 0 px2rem(-2px) px2rem(4px) 0 rgba(0,0,0,0.10);
    display: flex;
    align-items: center;
     .total {
       flex:1;
       margin-left: px2rem(20px);
       .total-name {
         vertical-align: middle;
       }
     }
     .price {
       @include font-dpr(24px);
       color: $base-color;
       vertical-align: middle;
     }
  }

  .place-order{
      float:right;
    @include font-dpr(18px);
      width: px2rem(134px);
      border:0;
      height: 100%;
      line-height:  px2rem(48px);
      background: $base-color;
      color: white;
    font-weight: bold;
    }
  button[disabled] {
    background: silver;
  }
  [v-cloak] {
    display: none;
  }
</style>
<template>
  <div class="wrapper">
    <div class="checkout">
    <div class="address" @click="goToAddressList()">
        <i class="pos-icon"></i>
        <div class="address-info" v-if="address && address.name">
          <p class="user">
            <span class="name">{{address.name}}</span>
            <span class="tel">{{address.tel}}</span>
          </p>
          <p class="street">
            {{address.street}}
          </p>
        </div>
        <div class="address-info" v-if="!address || !address.name">
          <p class="user">
            添加地址
          </p>
        </div>
        <i class="more-icon"></i>
    </div>
        <p class="bar"></p>
    <div class="goods-list">
        <div class="name">商品清单</div>
        <ul v-cloak>
          <li v-for='g in cartGoods' :key="g.name+g.spec">
            <p class="cart-item">
              <span>{{g.name}}{{g.spec ? ` [${g.spec}]`:""}}</span>
              <span class="price">¥{{Math.round(g.quantity * (g.customerPrice || g.price)*100)/100}}</span>
              <span style="float:right" v-if="g.unit2">(约{{Number(g.quantity).toFixed(2)}}{{g.unit|| '斤'}})</span>
              <span class="quantity">{{g.quantity/Number((g.unit2 && g.priceTransfer || 1))}}{{g.unit2 || g.unit || '斤'}}</span>
              <!--<span class='count-btn' @click='removeFromCart(g)'>-</span>-->
              <!--<span class='count-btn' @click='addToCart(g)'>+</span>-->
            </p>
          </li>
        </ul>
        <div class="delivery-fee"><span class="name">配送费</span><span class="value">¥0</span></div>
        <div class="total-fee"><span class="name">总计</span><span class="value">¥{{totalPrice}}</span></div>
    </div>

    <div class="order-info">
        <div class="delivery-time">
          <span class="name">配送时间</span>
          <select name="" id="time-select" v-model="deliveryTime">
            <option value="明天10:00-11:00">明天10:00-11:00</option>
            <option value="明天9:00-10:00">明天9:00-10:00</option>
            <option value="明天8:00-9:00">明天8:00-9:00</option>
            <option value="明天7:00-8:00" selected="selected">明天7:00-8:00</option>
            <option value="明天6:00-7:00">明天6:00-7:00</option>
          </select>
          <i class="more-select"></i>
        </div>
        <div class="order-notes">
          <span class="name">订单备注</span>
          <textarea placeholder="补充说明" v-model="notes" rows="4"></textarea>
        </div>
    </div>

    <!--div class="first-order">
        <span class="name">货到付款</span>
        <span class="back" :class="{'ball-check': reachPay}" @click="toggleReachPay()"><i class="ball"></i></span>
    </div-->

  </div>
  <div class="bottom-options">
         <p class="total"><span class="total-name">预估金额：</span><span class="price">¥{{totalPrice}}</span></p>
        <button class="place-order" @click='placeOrder()' :disabled="placingOrder">
            提交订单
        </button>
  </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'hello',
  data() {
    return {
      notes: '',
      msg: 'Welcome to Your Vue.js App',
      deliveryTime: '明天7:00-8:00',
      reachPay: false,
      showReachPay: false,
      placingOrder: false,
      wechatPayParams: null,
      orderId:null
    };
  },
  computed: {
    ...mapGetters({
       goods: 'allProducts',
      cartGoods: 'cartProducts',
      productCartNum: 'productCartNum',
      totalPrice: 'totalPrice',
      checkoutStatus: 'checkoutStatus',
      address: 'myAddress',
      config: 'config',
      forCustomer: 'forCustomer',
    }),
  },

  created() {
      this.$store.dispatch('getMyAddresses', this.forCustomer);
      this.getNotesFromStore()
      if(window.localStorage.getItem('zrb-first-order') != 'true'){
         this.showReachPay = true;
      }

    if(!this.goods.length) {
      this.$store.dispatch('getAllProducts');
    }

  },

  methods: {
    getNotesFromStore() {
      let notesStoreKey = this.forCustomer || 'own'
      notesStoreKey += '-notes'
      this.notes = localStorage.getItem(notesStoreKey)
    },
    saveNotesToStore() {
      let notesStoreKey = this.forCustomer || 'own'
      notesStoreKey += '-notes'
      localStorage.setItem(notesStoreKey, this.notes)
    },
    goToAddressList() {
      this.$router.push('/address');
    },
    placeOrder() {
      this.saveNotesToStore()
      if(!this.address.name) {
          alert("请填写配送地址");
          return;
      }
      if(!this.deliveryTime){
          alert("请填写配送时间");
          return;
      }
      if(confirm('确认下单?')){
        this.placingOrder = true;
        this.$store.dispatch('checkout', { forCustomer: this.forCustomer, order: { products: this.cartGoods, address: { name: this.address.name, tel: this.address.tel, street: this.address.street},notes: this.notes , dueTime:this.deliveryTime }})
          .then(response => {
              this.placingOrder = false;
              this.$store.dispatch('clearCart');
              this.$router.replace('/checkout-success/');
          }, error => {
              this.placingOrder = false;
          });
      }
    },
  }

};
</script>





// WEBPACK FOOTER //
// Checkout.vue?05b9f003